import styled from "styled-components"
import { useCheckByte } from "../../common/hook"
import mixins from "../../../styles/mixins";

const Wrap = styled.section`
    position: relative;
    background-color: rgba(225, 242, 237, 0.6) !important;
    overflow: hidden;
    height: ${(props) => props.line == 3 ? "122px" : "100%"};

    &::before {
        content: "";
        display: block;
        width: 378px;
        height: 244px;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("${process.env.PUBLIC_URL}/image/img_report_bg_ai_analysis_top.png");

    }
    &::after {
        content: "";
        display: block;
        width: 309px;
        height: 244px;
        position: absolute;
        bottom: 0;
        right: 0;
        background-image: url("${process.env.PUBLIC_URL}/image/img_report_bg_ai_analysis_bottom.png");

    }

    p {
        position: relative;
        height: 100%;
        overflow: hidden;
        z-index: 2;
        line-height: 22.4px;
        ${mixins.clampTextLine(props => props.line)}
    }

    .h3 {
        position: relative;
        z-index: 2;
        line-height: 20px;
    }
`
export default function AiAnalysisResult({text, hideTitle=false, line=8}) {
    return (
        <Wrap className="ai-analysis-result" line={line}>
            {
            !hideTitle &&
            <div className="h3">AI 분석 결과</div>
            }
            <p className="body2">
                {
                    text
                }
            </p>
        </Wrap>
    )
}